module.exports = __webpack_public_path__ + "static/img/weixin_code.9549d8ea.png";